function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1"
}, React.createElement("title", null, "Layer 1"), React.createElement("path", {
  className: "cls-1",
  d: "m51,99c0,-27.16895 22.83105,-50 50,-50l600,0c27.16895,0 50,22.83105 50,50l0,400c0,27.16895 -22.83105,50 -50,50l-600,0c-27.16895,0 -50,-22.83105 -50,-50l0,-400z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    "data-name": "Layer 1"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/screens-icon_1.10f55170.svg";
export { SvgComponent as ReactComponent };